const $ = require('jquery');
require('jquery-hoverintent');
const Modernizr = require('../../vendors/modernizr.min');
const _throttle = require('lodash/throttle');
const LazyLoad = require("./lazyload");
const WS = require('../../scripts/ws.js');

let $inPageNavLinks = $('.ws-in-page-nav a');
let Bootstrap = null;
let Stickyfill = null;
let lazyLoadExecuted = false;

function lazyPreloadThenInitInPageNav($linkToClickOnceLoaded) {
    // some lazy-loaded elements cause page height to change (such as knockout tabs) which can throw off the scroll target
    // calculation, so to prevent that we want to preemptively load these elements when the in-page nav is initialized
    LazyLoad.unveilAll($(".ws-nav-tabs-knockout-table-identifier.lazyload"));
    initInPageNav($linkToClickOnceLoaded);
}

function initInPageNav($linkToClickOnceLoaded) {
    let $body = $('body');
    let hasSitecoreRibbon = $body.hasClass('pagemode-edit') || $body.hasClass('pagemode-preview');
    let pageHeader = document.querySelector('.ws-nav');
    let tableOfContentsSelector = '.ws-clustered-table-of-contents';
    let tableOfContents = document.querySelector('body:not(.pagemode-edit) ' + tableOfContentsSelector);
    let inPageNavSelector = '.ws-in-page-nav';
    let inPageNav = document.querySelector('body:not(.pagemode-edit) ' + inPageNavSelector);
    let $inPageNav = $(inPageNav);
    let minifiedHeader = document.querySelector('.ws-body--minified-header .ws-minified-header');
    let minifiedHeaderProgress = 0;
    let minifiedHeaderBodyMargin = 0;
    let $minifiedHeaderWrapper = $('.ws-minified-header-wrapper');
    let $minifiedHeader = $(minifiedHeader);
    let minifiedHeaderOffset = $minifiedHeader.length ? $minifiedHeader.offset().top : 0;
    let $minifiedHeaderProgressIndicator = $('.ws-minified-header__progress-indicator');
    let minifiedHeaderProgressIndicatorHeight;
    let $minifiedHeaderProgressTarget = $('[data-progress-target]');
    let minifiedHeaderProgressTargetHeight;
    let $minifiedHeaderSubNav = $('.ws-minified-header__sub-nav');
    let $minifiedHeaderWidthConstraint = $minifiedHeader.find('.col-md-8.offset-md-2');
    let minifiedHeaderSubNavHeight = $minifiedHeaderSubNav.height() || 0;
    let minifiedHeaderSubNavTop = null;
    let initialMinifiedHeaderSubNavTop = null;
    let $stickyNavLinks = $('.ws-in-page-nav__link');
    let $mobileAccordions = $(".ws-content-block__category-header");
    let tabletMq = '(min-width: 768px)';
    let inPageNavLinkSelectedClass = 'ws-in-page-nav--selected';
    let $touchInPageListItems = $('.ws-in-page-nav__list-item');
    let $inPageListItems = $('.ws-in-page-nav__list-item > li');
    let $minifiedDisplayItems = $('.ws-minified-header__item--display_minified');
    let $minifiedPseudoFocusDisplayItems = $('.ws-pseudo-focus__link--minified-header-target');
    let isCurrentlySticky = false;
    let stickySupport = Modernizr.csspositionsticky;

    // A hidden, minified version of the header added to the page to calculate the height of the header when minified
    let $minifiedHeaderPlaceholder;

    // A hidden, unminified version of the header added to the page to occupy the same space as the actual header when unminified
    // This allows the actual header to be made "position:absolute", taking it out of the layout, so that when it transitions to "position:fixed", it does not cause a layout shift
    let $unminifiedHeaderPlaceholder;

    let minifiedHeaderHeight = 0,
        minifiedHeaderPadding = 0,
        fixedHeaderHeight = 0,
        pageHeaderOffset = 0,
        totalOffset = 0,
        scCrossPieceHeight = 0;

    // Add smooth scrolling to all sections on desktop tabs, this needs to be near the start of init to ensure it's attached before the user clicks 
    $inPageNavLinks.on('click', onInPageNavLinkClick);

    if (minifiedHeader) {
        // only include the logo on dark theme minified header
        if ($body.hasClass('ws-body--minified-header_dark')) {
            let $logo = $('.ws-nav__logo-icon-wrapper:not(.ws-nav__logo-icon-wrapper--print) > .ws-nav__logo-icon');
            if ($logo.length) {
                let $clonedLogo = $logo.clone();
                $clonedLogo.addClass('ws-nav__logo-icon--sticky-page-intro');
                $minifiedHeader.find('.ws-minified-header__content').append($clonedLogo);
            }
        }

        if (!$minifiedHeaderProgressIndicator.length && $('.ws-body--minified-header').data('ws-minified-header-show-progress')) {
            $minifiedHeaderProgressIndicator = $('<div class="ws-minified-header__progress-indicator">');
            $minifiedHeader.append($minifiedHeaderProgressIndicator);
        }

        // The minified header placeholder is added to the page in sticky mode to calculate the height of the minified header in sticky mode
        $minifiedHeaderPlaceholder = $minifiedHeader.clone().removeClass('ws-minified-header').addClass('ws-minified-header-placeholder sticky');
        cleanHeaderPlaceholder($minifiedHeaderPlaceholder, 'minified'); //! cleanup the minified placeholder markup to prevent conflicts/issues

        $minifiedHeaderPlaceholder.insertAfter($minifiedHeader);
        minifiedHeaderPadding = parseInt($minifiedHeaderPlaceholder.css('padding-top'), 10) + parseInt($minifiedHeaderPlaceholder.css('padding-bottom'), 10);
        
        // Another placeholder of the header, unminified, is added to the page, and the visible header is made "position:absolute" to take it out of the document flow
        // This prevents layout shift from occurring as the header minifies
        $unminifiedHeaderPlaceholder = $minifiedHeader.clone().removeClass('ws-minified-header').addClass('ws-minified-header-placeholder ws-minified-header-placeholder--unminified');
        cleanHeaderPlaceholder($unminifiedHeaderPlaceholder, 'unminified'); //! cleanup the unminified placeholder markup to prevent conflicts/issues
        
        $unminifiedHeaderPlaceholder.insertAfter($minifiedHeader);
        $minifiedHeader.addClass("ws-minified-header--has-placeholder");
    }

    if (minifiedHeader || inPageNav || tableOfContents) {
        onResize();
        onScroll();

        // throttle scrolling and resize events to improve performance
        // add the scroll-thottle class to any page that has scroll lagginess issues, to use a longer throttle interval
        const scrollThrottleInterval = $(".scroll-throttle").length ? 50 : 20;
        document.addEventListener('scroll', _throttle(onScroll, scrollThrottleInterval));
        window.addEventListener('resize', _throttle(onResize, 50));

        if (Bootstrap) {
            const scrollSpy = new Bootstrap.ScrollSpy($('main'), {
                target: '#navbar',
                threshold: [0, 1],
                rootMargin: "-45% 0px -50% 0px"
            });
        }
        else {
            Bootstrap = require('bootstrap');
            const scrollSpy = new Bootstrap.ScrollSpy($('main'), {
                target: '#navbar',
                threshold: [0, 1],
                rootMargin: "-45% 0px -50% 0px"
            });
        }
    }

    if (!$minifiedHeaderProgressTarget.length) {
        $minifiedHeaderProgressTarget = $('main');
    }

    if (!stickySupport) {
        if (Stickyfill) {
            Stickyfill.add($mobileAccordions);
        } else {
            import(/* webpackChunkName: "stickyfilljs" */ "stickyfilljs").then(({ default: stickyfill }) => {
                Stickyfill = stickyfill;
                Stickyfill.add($mobileAccordions);
            });
        }
    }

    /* This block works around an issue in Chrome where it scrolls to the top of the page when you click in a form element that is inside a sticky section. */
    let shareSelectorScrollX;
    let shareSelectorScrollY;

    $(document).on('mousedown', '.ws-fund-detail-page-intro__share-selector', function (e) {
        if (!$(this).is(':focus')) {
            shareSelectorScrollX = window.pageXOffset;
            shareSelectorScrollY = window.pageYOffset;
        }
    });

    $(document).on('focus', '.ws-fund-detail-page-intro__share-selector', function (e) {
        if (window.pageYOffset !== shareSelectorScrollY) {
            window.scrollTo(shareSelectorScrollX, shareSelectorScrollY);
        }
    });
    /* End Chrome workaround */

    $inPageNavLinks.on('keydown', function (e) {
        let $focusedItem = $(e.currentTarget);
        let closestLi = $focusedItem.closest('li');
        switch (e.which) {
            case 37:
                //left arrow
                e.preventDefault();
                closestLi.prev().find('a.ws-in-page-nav__link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                closestLi.next().find('a.ws-in-page-nav__link').focus();
                break;
            case 13:
                //enter
                onInPageNavLinkClick(e);

                let href = $focusedItem.attr('href');
                let hrefId = href.substring(1, href.length + 1);
                let anchor = document.getElementById(hrefId);
                let $anchorTag = $(anchor);
                $anchorTag.next().find('h2.ws-content__item.ws-heading.ws-heading--underlined.ws-heading--collapsible').attr("tabindex", "0").focus().removeAttr("tabindex");
                break;
            default:
                break;
        }
    });

    $stickyNavLinks.on('keydown', function (e) {
        let $focusedItem = $(e.currentTarget);
        switch (e.which) {
            case 37:
                //left arrow
                e.preventDefault();
                $focusedItem.closest('li').prev().find('a.ws-in-page-nav__link').focus();
                break;
            case 39:
                //right arrow
                e.preventDefault();
                $focusedItem.closest('li').next().find('a.ws-in-page-nav__link').focus();
                break;
            case 13:
                //enter
                let href = $focusedItem.attr('href');
                let hrefId = href.substring(1, href.length + 1);
                let anchor = document.getElementById(hrefId);
                let $anchorTag = $(anchor);
                $anchorTag.next().find('h2.ws-content__item.ws-heading.ws-heading--underlined.ws-heading--collapsible').focus();
                break;
            default:
                break;
        }
    });

    if ($body.hasClass('pagemode-edit')) {
        // in Experience Editor mode, we want to disable arrow key navigation so it doesn't interfere with editing
        $stickyNavLinks.off('keydown');
    }

    $mobileAccordions.on('click', function () {
        $(this).toggleClass("open");
        if (!$(this).hasClass("open")) {
            let $header = $(this);
            let $prev = $header.prev();
            $prev = $prev.length > 0 ? $prev : $header.parent();
            let headerTop = $prev.offset().top - pageHeaderOffset;

            // if the accordion we are closing will now be out of the viewport, scroll up to it
            if (headerTop < $(document).scrollTop()) {
                $('body, html').animate({
                    scrollTop: headerTop
                }, 100);
            }
        }
    });

    $minifiedDisplayItems.on('focusin', function () {
        // if we've tabbed to a item in the minified header that is only shown while minified, we want to scroll enough to minify the header, if it hasn't already been
        if (!isCurrentlySticky) {
            $('body, html').animate({
                scrollTop: minifiedHeaderOffset
            }, 100);
        }
    });

    $minifiedPseudoFocusDisplayItems.on('focusin', function () {
        // if we've tabbed to a item in the minified header that is only shown while minified, we want to scroll enough to minify the header, if it hasn't already been
        if (!isCurrentlySticky) {
            $('body, html').animate({
                scrollTop: minifiedHeaderOffset
            }, 100);
        }
    });

    if (Modernizr.browsertouch) {
        $touchInPageListItems.on('click', function (event) {
            if (Modernizr.mq(tabletMq)) {
                let $target = $(event.currentTarget),
                    $li = $target.parent();

                event.preventDefault();
                event.stopPropagation();

                if (!$li.hasClass(inPageNavLinkSelectedClass)) {
                    $inPageListItems.removeClass(inPageNavLinkSelectedClass);
                    $li.addClass(inPageNavLinkSelectedClass);
                }
                else {
                    $inPageListItems.removeClass(inPageNavLinkSelectedClass);
                }
            }
        });
    }
    else {
        $inPageListItems.hoverIntent({
            over: function (event) {
                if (Modernizr.mq(tabletMq)) {
                    $inPageListItems.removeClass(inPageNavLinkSelectedClass);
                    $target.addClass(inPageNavLinkSelectedClass);
                }
            },
            out: function (event) {
                if (Modernizr.mq(tabletMq)) {
                    if ($(event.currentTarget).hasClass(inPageNavLinkSelectedClass)) {
                        $target.addClass(inPageNavLinkSelectedClass);
                    }
                }
            },
            timeout: 500
        });
    }

    if ($linkToClickOnceLoaded && $linkToClickOnceLoaded.length) {
        $linkToClickOnceLoaded.click();
    }

    function cleanHeaderPlaceholder($headerPlaceholder, placeholderIdSuffix) {
        if (WS.isExperienceEditor()) {
            // remove sitecore "chromes" from the placeholder to prevent conflicts
            $headerPlaceholder.find(".scLooseFrameZone, code[type='text/sitecore'][kind='open']").remove();
            $headerPlaceholder.find(".scWebEditInput, .scEnabledChrome").removeClass("scWebEditInput").removeClass("scEnabledChrome")
                .removeAttr("id").removeAttr("sc-part-of").removeAttr("scfieldtype");
        }

        // we don't want the placeholder to show up in heading lists for screen readers; this shouldn't change styling since it's all based on classes
        $headerPlaceholder.find('h1,h2,h3,h4,h5,h6').each((index, element) => WS.replaceTag($(element), 'span'));

        // to avoid duplicate id's on the page, change any elements with an id defined
        $headerPlaceholder.find('[id]').each((index, element) => element.id += `-placeholder-${placeholderIdSuffix}`);
        $headerPlaceholder.find('[for]').each((index, element) => element.setAttribute('for', element.getAttribute('for') + `-placeholder-${placeholderIdSuffix}`));
    }

    function recalculatePositions() {
        pageHeaderOffset = calculatePageHeaderOffset();
        minifiedHeaderHeight = ($minifiedHeaderPlaceholder && $minifiedHeaderPlaceholder.length) ? ($minifiedHeaderPlaceholder.height() + minifiedHeaderPadding + scCrossPieceHeight) - 1 : 0;
        fixedHeaderHeight = minifiedHeaderHeight || calculatePageHeaderOffset();
        totalOffset = calculateTotalHeaderOffset();
        minifiedHeaderProgressIndicatorHeight = $minifiedHeaderProgressIndicator.outerHeight() || 0;
        minifiedHeaderProgressTargetHeight = $minifiedHeaderProgressTarget.outerHeight() || 0;
        minifiedHeaderBodyMargin = minifiedHeaderHeight - 5 - (isCurrentlySticky ? scCrossPieceHeight : 0);
    }

    function calculatePageHeaderOffset() {
        return pageHeader ? pageHeader.offsetTop + pageHeader.offsetHeight : 0;
    }

    function calculateTotalHeaderOffset() {
        return fixedHeaderHeight + minifiedHeaderSubNavHeight;
    }

    function adjustForEERibbon(forceAdjust) {
        if (hasSitecoreRibbon) {
            let $scCrossPiece = $('#scCrossPiece');
            if ($scCrossPiece.length) {
                let outerHeight = $scCrossPiece.outerHeight();

                if (forceAdjust || scCrossPieceHeight !== outerHeight) {
                    scCrossPieceHeight = outerHeight;
                    const offset = isCurrentlySticky ? `${scCrossPieceHeight}px` : '';
                    $minifiedHeader.css('top', offset);

                    recalculatePositions();
                    setNavClasses();
                }
            }
        }
    }

    function onResize() {
        adjustForEERibbon();
        recalculatePositions();
        setNavClasses();
    }

    function onScroll() {
        let wasStickyBeforeScroll = isCurrentlySticky;

        if (window.pageYOffset >= minifiedHeaderOffset - scCrossPieceHeight - 5) {
            if (!isCurrentlySticky) {
                isCurrentlySticky = true;
                $minifiedHeaderWrapper.addClass('sticky');
                $minifiedHeader.addClass('sticky');
            }

            // Remove narrow width constraint on Thought Leadership articles so it extends entire page width
            if ($minifiedHeaderWidthConstraint.length) {
                $minifiedHeaderWidthConstraint.removeClass('col-md-8 offset-md-2');
            }

            updateProgressIndicator();

            if ($minifiedHeaderSubNav.length) {
                if (initialMinifiedHeaderSubNavTop === null) {
                    initialMinifiedHeaderSubNavTop = $minifiedHeaderSubNav.offset().top;
                }

                if (window.pageYOffset >= initialMinifiedHeaderSubNavTop - fixedHeaderHeight - 1) {
                    $minifiedHeaderSubNav.addClass('sticky');

                    if (!stickySupport) {
                        $minifiedHeaderSubNav.addClass('ws-minified-header__sub-nav--pseudo-sticky');
                    }

                    $mobileAccordions.each(function (i, item) {
                        let $this = $(this);
                        let thisTop = $this.offset().top;

                        let offsetTop = thisTop - fixedHeaderHeight;
                        let offsetBottom = offsetTop + $this.height();

                        if (window.pageYOffset >= thisTop - fixedHeaderHeight - 1 && window.pageYOffset < offsetBottom) {
                            $this.addClass('sticky');
                        } else {
                            $this.removeClass('sticky');
                        }
                    });
                } else {
                    $minifiedHeaderSubNav.removeClass('sticky');

                    if (!stickySupport) {
                        $minifiedHeaderSubNav.removeClass('ws-minified-header__sub-nav--pseudo-sticky');
                    }
                }
            }

            setNavClasses();
        } else {
            if (isCurrentlySticky) {
                isCurrentlySticky = false;
                $minifiedHeaderWrapper.removeClass('sticky');
                $minifiedHeader.removeClass('sticky');
                $minifiedHeaderSubNav.removeClass('sticky');
            }

            // Restore narrow width constraint on article headers
            if ($minifiedHeaderWidthConstraint.length) {
                $minifiedHeaderWidthConstraint.addClass('col-md-8 offset-md-2');
            }

            if (!stickySupport) {
                $minifiedHeaderSubNav.removeClass('ws-minified-header__sub-nav--pseudo-sticky');
            }
        }

        // force an adjustment if stickiness changed, otherwise, it will only adjust if the ribbon size changes
        adjustForEERibbon(wasStickyBeforeScroll !== isCurrentlySticky);
    }

    function setNavClasses() {
        let headerHeightPx = fixedHeaderHeight + 'px';

        if (minifiedHeaderSubNavTop !== fixedHeaderHeight) {
            // adjust the subnav position e.g. when window is resized, causing text in the header to wrap, changing the minified header height
            minifiedHeaderSubNavTop = fixedHeaderHeight;
            $minifiedHeaderSubNav.css({ 'top': headerHeightPx });
        }

        updateProgressIndicator();
    }

    function updateProgressIndicator() {
        if ($minifiedHeaderProgressTarget.length) {
            let adjustedOffset = Math.max(0, window.pageYOffset + minifiedHeaderBodyMargin + minifiedHeaderProgressIndicatorHeight - $minifiedHeaderProgressTarget.offset().top);
            let progressTarget = minifiedHeaderProgressTargetHeight - window.innerHeight * 2 / 3; // progress is "complete" when the end of the article is in the top two-thirds of the viewport
            let progressPct = 0.1 + adjustedOffset / Math.max(1, progressTarget) * 100;

            // for performance reasons, we don't want to change the css every single scroll event by a miniscule amount, so only do it if it changes by 0.1% or more
            if (Math.floor(progressPct * 10) !== Math.floor(minifiedHeaderProgress * 10)) {
                minifiedHeaderProgress = Math.min(100, Math.max(0, progressPct));
                $minifiedHeaderProgressIndicator.css("width", minifiedHeaderProgress + "%");
            }
        }
    }

    // Function that handles the click event on in-page navigation links
    function onInPageNavLinkClick(e) {
        const link = e.currentTarget;

        if (link.hash === "") {
            return;
        }

        e.preventDefault();

        const $targetElement = $(link.hash);
        const $allContentBlocks = $('.ws-content-block');

        $(inPageNav).addClass('ws-in-page-nav--animating');

        // Load lazy-loaded children for each content block only once
        if (!lazyLoadExecuted) {
            $allContentBlocks.each(function () {
                LazyLoad.unveilAllChildren($(this));
            });

            lazyLoadExecuted = true;
        }

        // Calculate target scroll position based on the target element
        const target = calculateScrollTargetPosition($targetElement);

        // Animate scrolling to the target position
        $('html, body').animate({ scrollTop: target }, 100);

        $(inPageNav).removeClass('ws-in-page-nav--animating');
    }

    function calculateScrollTargetPosition($targetElement) {
        let target = $targetElement.offset().top - totalOffset + 2;

        if (!isCurrentlySticky) {
            target += minifiedHeaderBodyMargin - minifiedHeaderSubNavHeight;
        }

        return target;
    }
}

let executed = false;
$(function () {
    //! 1) Begin initialization of in-page nav on:
    //!     A) first mouseover or focus of an IN PAGE NAV
    //!     B) first click of any link within IN PAGE NAV
    //!     C) first window scroll

    $(".ws-in-page-nav").one("mouseover focus", function (event) {
        if (!executed) {
            executed = true;
            lazyPreloadThenInitInPageNav();
        }
    });

    $inPageNavLinks.one("click", function (event) {
        if (!executed) {
            executed = true;
            event.preventDefault();
            lazyPreloadThenInitInPageNav($(this));
        }
    });

    $(window).one("scroll", function (event) {
        if (!executed) {
            executed = true;
            lazyPreloadThenInitInPageNav();
        }
    });

    //if page is refreshed and the sticky header should already be active run the script.
    if ($(window).scrollTop() !== 0) {
        if (!executed) {
            executed = true;
            lazyPreloadThenInitInPageNav();
        }
    }
});

